<template>
    <v-flex class="profile-details">
        <v-flex class="profile-details__image">
            <figure>
                <img id="userPhoto" data-qe-id="userPhoto1"
                     :src="sizeFormattedImageUrl(profileImageComputed, 350, 350)"
                     @error="profileImageFailHandler" v-if="(isProfileImageExist || !isCurrentUser)">
                <img id="userPhoto2" data-qe-id="userPhoto2" src="" v-if="(!isProfileImageExist && isCurrentUser)">
                <v-btn data-qe-id="add-photo_btn" @click="openPhotoDialog()" v-if="!isProfileImageExist && isCurrentUser">
                    <span>{{memberProfileConstants.ADD_PHOTO}}</span>
                    <i class="fas fa-image"></i>
                </v-btn>
            </figure>
            <i v-if="isProfileImageExist && isCurrentUser"  data-qe-id="open-photo_dialog-btn" class="fas fa-camera" @click="openPhotoDialog()"></i>
            <!-- TODO profile online status (green marble) should be hidden until Presence has been developed -->
            <!-- <span class="online-status online" v-if="!userProfile.isFormerMember"></span> -->
        </v-flex>
        <v-flex class="profile-details__info">
            <v-flex class="member_name" v-if="userProfile">{{userName() }}
                <v-flex v-if="!userProfile.isFormerMember && userProfile.memberBadge" tag="label" :class="isLifeTimeMember">{{userProfile.memberBadge}}</v-flex>
                <v-flex v-if="userProfile.isFormerMember && !isGrandFather" tag="label" class="former_member">{{memberProfileConstants.FORMER_MEMBER}}</v-flex>
                <i v-if="isCurrentUser" data-qe-id="profile-summary_edit_btn" @click.stop="showProfileSummaryEdit=true" class="fas fa-pencil-alt"> </i>
                <profile-summary-edit v-model="showProfileSummaryEdit" :memberId="memberId" v-if="showProfileSummaryEdit" />
            </v-flex>
            <v-flex class="details">
                <v-flex class="member_name__min-height">
                    <span v-if="userProfile.businessTitle || userProfile.companyName">{{userJobTitle()}} <a v-if="userProfile.companyName && !userProfile.companyWebsite" href="#" data-qe-id="memberprofile_ProfessionalExperience" v-scroll-to="{ el: '#ProfessionalExperience', offset: -100 }">{{userProfile.companyName}}</a>
                    <a v-if="userProfile.companyName && userProfile.companyWebsite" :href="normalizeUrl(userProfile.companyWebsite)" target="_blank" data-qe-id="memberprofile_ProfessionalExperience">{{userProfile.companyName}}</a></span>
                    <span v-if="userProfile.city || userProfile.state || userProfile.country">
                    <em v-if="userProfile.city">{{userAddressCity()}}</em>
                    <em v-if="userProfile.state">{{userProfile.state}}</em>
                    <em v-if="userProfile.country">{{userAddress()}}</em>
                </span>
                <span v-if="(!isChapterManager && !userProfile.isFormerMember) || isGrandFather">
                    <a v-if="(userProfile.primaryChapterName && !userProfile.isFormerMember)|| isGrandFather"
                       data-qe-id="forward-to-chapter_link"
                       @click="chapterForward(userProfile)">{{userProfile.primaryChapterName}}
                    </a>
                    <!-- TODO: Removing All Communities shortcut as per US15918
                    <a v-if="isYpoCommunitiesVisible && !userProfile.isFormerMember" href="#" data-qe-id="memberprofile_AllCommunities" v-scroll-to="{ el: '#YpoCommunities', offset: -100 }">{{memberProfileConstants.ALL_COMMUNITIES}}</a> -->
                    <em v-if="userProfile.ypoMemberType">{{userMemberSince()}}</em>
                    <v-flex v-if="userProfile.ypoGoldBadge && !userProfile.isFormerMember" tag="label" class="label-gold">{{memberProfileConstants.YPO_GOLD}}</v-flex>
                </span>
                <span v-if="isChapterManager">
                    <em>{{userProfile.ypoMemberType}}</em>
                    <a v-if="($vuetify.breakpoint.xs || $vuetify.breakpoint.sm || $vuetify.breakpoint.md) && userProfile.chapterInfo.length" @click="getFirstChapterUrl()">{{getFirstChapterName()}}</a>
                    <em v-if="($vuetify.breakpoint.xs || $vuetify.breakpoint.sm || $vuetify.breakpoint.md) && userProfile.chapterInfo.length">{{andMore()}}</em>
                    <a v-else-if="userProfile.chapterInfo.length" v-for='(chapter, index) in userProfile.chapterInfo' :key='index' @click="chapterRedirect(chapter.chapterName, chapter.chapterId)">{{` | ${chapter.chapterName}`}}</a>
                </span>
                </v-flex>
                <strong data-qe-id="memberprofile_connected" @click="connectUser(false)" v-if="(isConnected || isConnectVisible) && !this.$vuetify.breakpoint.xs"><i class="fas fa-heart"></i>{{memberProfileConstants.FAVORITE}}</strong>
                <div v-if="isMobile" class="mobile-buttons">
                    <button v-if="isConnected || isConnectVisible || isAddToConnectVisible"
                         @click="scrollToContact" class="action-button">
                        <i class="fa fa-comment"></i> {{ memberProfileConstants.CONTACT_ME }}
                    </button>
                    <button
                        v-if="isConnected || isConnectVisible || isAddToConnectVisible"
                        @click="toggleFavorite(isConnected)"
                        :class="{'notConnected': !isConnected}"
                        class="action-button">
                        <i class="fas fa-heart"></i>
                        {{ isConnected || isConnectVisible ? memberProfileConstants.FAVORITE : memberProfileConstants.ADD_TO_FAVORITE }}
                    </button>
                </div>
                <strong data-qe-id="memberprofile_addToConenction" @click="connectUser(true)" class="notConnected" v-if="!isConnected && isAddToConnectVisible && !this.$vuetify.breakpoint.xs">{{memberProfileConstants.ADD_TO_FAVORITE}}</strong>
                <strong v-if="userProfile.isFormerMember && !isGrandFather" class="notConnected">
                {{ memberProfileConstants.PLEASE_DO_NOT_SOLICIT }}
                </strong>
            </v-flex>
        </v-flex>
        <v-dialog scrollable v-model="uploadPhotoDialog" content-class="medium">
            <v-card class="myprofile-popup" v-if="uploadPhotoDialog">
                <v-card-title primary-title>
                    {{memberProfileConstants.PROFILE_PHOTO.PROFILE_PHOTO_EDIT}}
                    <i class="fas fa-times" data-qe-id="cancel_dialog_btn" @click="uploadPhotoDialog = false"></i>
                </v-card-title>
                <v-card-text class="upload-photo inner-scrollbar">
                    <croppa
                        v-if="isCurrentUser && !$vuetify.breakpoint.xs"
                        v-model="croppa"
                        :width="400"
                        :height="400"
                        canvas-color="transparent"
                        :placeholder="memberProfileConstants.PROFILE_PHOTO.UPLOAD_PHOTO_DESC"
                        :placeholder-font-size="18"
                        :prevent-white-space="true"
                        :show-remove-button="false"
                        @new-image-drawn="onNewImage"
                        @zoom="onZoom"
                        @init="onInit"
                        :initial-image="exisitingImage"
                        :key="exisitingImage"
                        accept=".jpeg,.png,.jpg">
                    </croppa>
                    <croppa
                        v-if="isCurrentUser && $vuetify.breakpoint.xs"
                        v-model="croppa"
                        :width="200"
                        :height="200"
                        canvas-color="transparent"
                        :placeholder="memberProfileConstants.PROFILE_PHOTO.UPLOAD_PHOTO_DESC"
                        :placeholder-font-size="18"
                        :prevent-white-space="true"
                        :show-remove-button="false"
                        @new-image-drawn="onNewImage"
                        @zoom="onZoom"
                        @init="onInit"
                        :initial-image="exisitingImage"
                        :key="exisitingImage"
                        accept=".jpeg,.png,.jpg">
                    </croppa>
                </v-card-text>
                <status-bar :action="uploadPhotoAction"></status-bar>
                <v-card-actions>
                    <v-layout row wrap>
                    <v-flex xs12 sm6>
                        <v-flex class="upload-photo__actions">
                            <i class="fas fa-user"></i>
                            <input type="range" class="slider" @input="onSliderChange" :min="sliderMin" :max="sliderMax" step=".001" v-model="sliderVal">
                            <i class="fas fa-user"></i>
                            <span class="rotate_btn">
                            <v-btn icon @click="croppa.rotate()"><i class="fas fa-undo"></i></v-btn>
                            <label>{{memberProfileConstants.PROFILE_PHOTO.ROTATE}}</label>
                            <v-btn icon @click="croppa.rotate(-1)"><i class="fas fa-redo"></i></v-btn>
                        </span>
                        </v-flex>
                    </v-flex>
                    <v-flex class="upload-photo__controls" xs12 sm6 text-xs-center text-sm-right>
                        <v-flex ma-2>
                            <v-btn flat class="primary_btn transparent" @click="croppa.chooseFile()" data-qe-id="choose-another-photo_btn">
                                {{memberProfileConstants.PROFILE_PHOTO.CHOOSE_ANOTHER_PHOTO}}
                            </v-btn>
                            <v-btn flat class="primary_btn" data-qe-id="save-photo_btn" @click="photoUpload()">
                                {{appCommonConstants.DONE}}
                            </v-btn>
                        </v-flex>
                    </v-flex>
                    </v-layout>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-flex>
</template>

<script>
    import { memberProfileConstants } from "./memberProfile.constants.js";
    import { mapState, mapActions, mapGetters, mapMutations } from "vuex";
    import { storeAction } from "../../store/storeActions.constant";
    import { storeGetters } from "../../store/storeGetters.constant";
    import { storeMutation } from "../../store/storeMutations.constant";
    import { appCommonConstants } from "../appCommon.constants.js";
    import FileUpload from 'vue-upload-component';
    import 'vue-croppa/dist/vue-croppa.css';
    import ProfileSummaryEdit from './EditDialogues/ProfileSummaryEdit';
    import StatusBar from "../StatusBar/StatusBar";
    import { eventBus } from '../../main';
    import StatusOverlay from '../StatusOverlay/StatusOverlay';
    import { gaDataLayerEvent } from '../../plugins/analytics';
    import { getHbRedirectByCommunityId } from "@/common/utils/hivebriteUtils";
    import { gtmEventName } from "@/plugins/gtmAnalytics";
    import { normalizeUrl } from '@/common/utils/utils';
    import { sizeFormattedImageUrl } from "@/common/utils/cloudinaryUtils";

    export default {
        name: "MemberProfileHeader",
        data: () => ({
            normalizeUrl,
            memberProfileConstants,
            appCommonConstants,
            uploadPhotoDialog: false,
            croppa: {},
            sliderVal: 0,
            sliderMin: 0,
            sliderMax: 0,
            showProfileSummaryEdit: false,
            exisitingImage: null,
            profileImageFailureFlags: {},
            sizeFormattedImageUrl,
        }),
        components: {
            FileUpload,
            ProfileSummaryEdit,
            StatusBar,
            StatusOverlay,
        },
        props: {
            memberId: {
                type: String,
                required: true,
            },
            isConnected: {
                type: Boolean,
                required: false,
            },
        },
        created() {
            this.getProfileConnection(this.memberId);
            eventBus.$on('uploadPhotoDialog', ((value) => {
                this.uploadPhotoDialog = value;
            }));
        },
        methods: {
            ...mapActions({
                getProfileConnection: `memberProfile/${storeAction.getProfileConnection}`,
                addConnection: `memberProfile/${storeAction.addConnection}`,
                uploadProfilePhoto: `memberProfile/${storeAction.uploadProfilePhoto}`,
            }),
            ...mapMutations({
                setUserProfileImageExists: `memberProfile/${storeMutation.setUserProfileImageExists}`,
            }),
            userName() {
                if (this.userProfile.preferredName) {
                    return `${this.userProfile.preferredName} ${this.userProfile.lastName}`;
                }
                return `${this.userProfile.firstName} ${this.userProfile.lastName}`;
            },
            chapterForward(user) {
              const chapterItem = this.networkChapters.find(item => item.name === user.primaryChapterName) || null;
              if (chapterItem) {
                const hbRedirectCommunity = getHbRedirectByCommunityId(this.connectPlusRedirects, chapterItem.id);
                if (hbRedirectCommunity) {
                  window.open(hbRedirectCommunity.redirectUrl, '_self');
                } else {
                  this.$router.push({
                    path: `/${chapterItem.type.toLowerCase()}/${chapterItem.id}`,
                    query: { name: chapterItem.name },
                  });
                }
              }
            },
            chapterRedirect(chapterName, chapterId) {
                if (chapterName && chapterId) {
                    this.$router.push({
                        path: `/chapter/${chapterId}`,
                        query: { name: chapterName },
                    });
                }
            },
            connectUser(connect) {
                const requestBody = {
                ...this.profileConnection,
                isConnected: connect
                };

                this.addConnection(requestBody)
                .then(() => {
                    this.getProfileConnection(this.memberId);
                    if (connect) {
                        gaDataLayerEvent(gtmEventName.C_Profile_Add_To_Connections, this.memberId);
                    }
                });
            },
            userJobTitle() {
                if (this.userProfile.businessTitle && this.userProfile.companyName) {
                    return `${this.userProfile.businessTitle} ${this.memberProfileConstants.AT}`;
                }
                return this.userProfile.businessTitle;
            },
            userAddress() {
                if ((this.userProfile.city || this.userProfile.state) && this.userProfile.country) {
                    return ` | ${this.userProfile.country}`;
                }
                return this.userProfile.country;
            },
            userAddressCity() {
                if (this.userProfile.city && this.userProfile.state) {
                    return `${this.userProfile.city}, `;
                }
                return this.userProfile.city;
            },
            userMemberSince() {
                // eslint-disable-next-line no-nested-ternary
                return this.userProfile.ypoMemberType === this.memberProfileConstants.MEMBER ?
                    `${this.userProfile.primaryChapterName != null ? "|" : ""} ${this.userProfile.ypoMemberType} ${this.userProfile.memberJoinDate != null ? this.memberProfileConstants.SINCE : ""} ${this.userProfile.memberJoinDate != null ? this.userProfile.memberJoinDate : ""}`
                    // eslint-disable-next-line no-nested-ternary
                    : this.isYpoCommunitiesVisible && !this.userProfile.isFormerMember ?
                    `${this.userProfile.primaryChapterName != null ? "|" : ""} ${this.userProfile.ypoMemberType}` :
                    this.isGrandFather ?
                    this.memberProfileConstants.GRAND_FATHER_MEMBER_TEXT :
                    this.userProfile.ypoMemberType;
            },
            photoUpload() {
                const url = this.croppa.generateDataUrl();
                const postbody = {
                    PersonId: this.memberId,
                    imageData: url.slice(22),
                };
                this.uploadProfilePhoto(postbody)
                    .then((res) => {
                        this.exisitingImage = res;
                        this.uploadPhotoDialog = false;
                        this.sliderVal = 0;
                        this.setUserProfileImageExists(true);
                        gaDataLayerEvent(gtmEventName.C_Profile_Edit_Profile_Image, `${this.memberId}${this.isRedirectFromConnectPlus ? ' | Connect+ Redirect' : ''}`);
                    });
            },
            openPhotoDialog() {
                this.uploadPhotoDialog = true;
                this.sliderVal = 0;
            },
            onNewImage() {
                this.sliderVal = this.croppa.scaleRatio;
                this.sliderMin = this.croppa.scaleRatio / 2;
                this.sliderMax = this.croppa.scaleRatio * 2;
            },
            onSliderChange(evt) {
                const increment = evt.target.value;
                this.croppa.scaleRatio = +increment;
            },
            onZoom() {
                this.sliderVal = this.croppa.scaleRatio;
            },
            onInit() {
                this.croppa.addClipPlugin((ctx, x, y, w, h) => {
                    ctx.beginPath();
                    /* Croppa Caluculation:
                     * ctx: canvas context
                     * x: start point (top-left corner) x coordination
                     * y: start point (top-left corner) y coordination
                     * w: croppa width
                     * h: croppa height
                     */
                    ctx.arc((x + w) / 2, (y + h) / 2, w / 2, 0, 2 * Math.PI, true);
                    ctx.closePath();
                });
            },
            profileImageFailHandler() {
                const desiredImage = this.profileImageUrl;
                this.profileImageFailureFlags = {
                    ...this.profileImageFailureFlags,
                    [desiredImage]: true,
                };
                this.setUserProfileImageExists(false);
            },
            isCurrentUserWasFormerMember() {
                return this.profileInformation && this.profileInformation.recordTypeName.toLowerCase() === this.memberProfileConstants.FORMER_MEMBER.toLowerCase();
            },
            getFirstChapterName() {
                return this.userProfile.chapterInfo.length ? ` | ${this.userProfile.chapterInfo[0].chapterName}` : '';
            },
            getFirstChapterUrl() {
                return this.chapterRedirect(this.userProfile.chapterInfo[0].chapterName, this.userProfile.chapterInfo[0].chapterId);
            },
            andMore() {
                return this.userProfile.chapterInfo && this.userProfile.chapterInfo.length > 1 ? this.memberProfileConstants.AND_MORE : '';
            },
            toggleFavorite(currentValue) {
                this.$emit('update:isConnected', !currentValue);
                this.connectUser(!currentValue);
            },
            scrollToContact() {
                this.$emit('scroll-to-contact');
            },
        },
        computed: {
            ...mapState("actionState", ["actions"]),
            ...mapGetters({
                networkChapters: `memberProfile/${storeGetters.networkChapters}`,
                userProfile: `memberProfile/${storeGetters.userProfile}`,
                profileConnection: `memberProfile/${storeGetters.profileConnection}`,
                currentUserId: `memberProfile/${storeGetters.currentUserId}`,
                isYpoCommunitiesVisible: `memberProfile/${storeGetters.isYpoCommunitiesVisible}`,
                chapterAdminEditable: `memberProfile/${storeGetters.chapterAdmin}`,
                profileInformation: `myAccount/${storeGetters.profileInformation}`,
                isMobileAppBrowser: `${[storeGetters.isMobileAppBrowser]}`,
                connectPlusRedirects: `connectPlus/${storeGetters.connectPlusRedirects}`,
            }),
            isRedirectFromConnectPlus() {
              return this.$route && this.$route.query
                  && this.$route.query.connectPlusRedirect && this.$route.query.connectPlusRedirect === 'true';
            },
            isConnectVisible() {
                return this.profileConnection.isConnected && (this.isGrandFatherFormerMember || !this.userProfile.isFormerMember) && !this.isCurrentUser;
            },
            isAddToConnectVisible() {
                return !this.profileConnection.isConnected && (this.isGrandFatherFormerMember || !this.userProfile.isFormerMember) && !this.isCurrentUser;
            },
            isLifeTimeMember() {
                return this.userProfile.memberBadge === this.memberProfileConstants.LIFETIME ?
                'gold' :
                'new';
            },
            isCurrentUser() {
                return this.memberId === this.currentUserId || this.chapterAdminEditable;
            },
            uploadPhotoAction() {
                return this.actions[storeAction.uploadProfilePhoto];
            },
            profileImageUrl() {
                return this.userProfile.profileImageUrl;
            },
            profileImageComputed() {
                if (this.userProfile.profilePictureuploaded) {
                    const desiredImage = this.profileImageUrl;
                    if (this.profileImageFailureFlags[desiredImage]) {
                        return this.userProfile.fallbackProfileImageUrl;
                    }
                    // eslint-disable-next-line
                    this.exisitingImage = desiredImage;
                    return desiredImage;
                }
                return this.userProfile.fallbackProfileImageUrl;
            },
            isProfileImageExist() {
                const desiredImage = this.profileImageUrl;
                if (this.profileImageFailureFlags[desiredImage]) {
                    return false;
                }
                this.setUserProfileImageExists(true);
                return true;
            },
            isGrandFather() {
                return this.userProfile.ypoMemberType === memberProfileConstants.GRAND_FATHER_MEMBER;
            },
            isGrandFatherFormerMember() {
                return this.userProfile.ypoMemberType === memberProfileConstants.GRAND_FATHER_MEMBER && this.userProfile.isFormerMember;
            },
            isChapterManager() {
                return this.userProfile.ypoMemberType === memberProfileConstants.CHAPTER_ADMIN || this.userProfile.ypoMemberType === memberProfileConstants.CHAPTER_MANAGER;
            },
            isDesktop() {
                return !this.$vuetify.breakpoint.xs;
            },
            isMobile() {
                return this.$vuetify.breakpoint.xs;
            },
        },
    };
</script>

<style lang="scss" scoped>
    @import "../../common/styles/_colors.scss";
    @import "../../common/styles/_responsive.scss";
    .profile-details {
        position: relative;

        &__image {
            position: absolute;
            width: 158px;
            height: 158px;
            left: 15px;
            top: 0;
        }

        .fa-camera {
            border: 2.6px solid $ypo-open-blue-gray;
            width: 30px;
            height: 30px;
            position: absolute;
            right: -10px;
            top: 70px;
            z-index: 1;
            border-radius: 50%;
            background: $ypo-cta;
            text-align: center;
            line-height: 24px;
            color: $white;
            cursor: pointer;
        }

        .online-status {
            border: 2.6px solid $ypo-open-blue-gray;
            width: 30px;
            height: 30px;
            position: absolute;
            right: 15px;
            top: 120px;
            z-index: 1;
            border-radius: 50%;

            &.online {
                background: radial-gradient(circle, $ypo-light-green 0%, $ypo-medium-green 100%);
            }

            &.busy {
                background: radial-gradient(circle, $ypo-error-red 0%, $ypo-red 100%);
            }

            &.offline {
                background: radial-gradient(circle, $ypo-prospect-list-border 0%, $ypo-duskblue 100%);
            }
        }

        figure {
            height: 100%;
            border-radius: 150px;
            width: 100%;
            overflow: hidden;
            text-align: center;
            border: 8px solid $ypo-open-blue-gray;
            position: relative;

            img {
                max-width: 100%;
                width: 100%;
                height: 100%;
            }

            .v-btn {
                background: $ypo-cta !important;
                color: $white;
                bottom: 0;
                cursor: pointer;
                right: 0;
                font-weight: 600;
                padding: 10px 27px 60px;
                margin: 0;
                overflow: hidden;
                width: 100%;
                top: 75px;
                position: absolute;

                i {
                    display: block;
                    font-size: 24px;
                    margin-top: 5px;
                }

                &__content {
                    display: initial !important;
                }
            }
        }

        &__info {
            padding: 0px 0 0 210px;
            min-height: 160px;

            .member_name {
                color: $ypo_blue;
                font-size: 22px;
                font-weight: bold;
                letter-spacing: -0.54px;
                line-height: 30px;
                margin-bottom: 10px;

                label {
                    color: $white;
                    font-size: 12px;
                    font-weight: 500;
                    letter-spacing: 0.59px;
                    line-height: 12px;
                    padding: 3px 20px;
                    margin: 0px 0 0 5px;
                    position: relative;
                    top: -4px;
                }

                .new {
                    background: $ypo_blue;
                    text-transform: uppercase;
                }

                .gold {
                    background: $ypo-gold;
                    text-transform: uppercase;
                }

                .former_member {
                    background: $ypo-gray;
                }

                &__min-height {
                    min-height: 70px;
                }

                i {
                    color: $ypo-dark-background-gray;
                    font-size: 16px;
                    position: relative;
                    left: 5px;
                    margin-left: 20px;
                    cursor: pointer;

                    &:hover {
                        color: $ypo-cta;
                    }
                }
            }

            .details {
                font-family: "Raleway", sans-serif;
                font-size: 14px;
                font-weight: 500;
                line-height: 15px;
                color: $ypo-dark-gray;

                span {
                    display: block;
                    margin-bottom: 10px;

                    em {
                        font-style: normal;
                    }

                    .label-gold {
                        font-size: 10px;
                        cursor: default;
                        background: $ypo_gold;
                        color: $white;
                        font-weight: 500;
                        padding: 3px 5px;
                        line-height: 12px;
                        margin-left: 5px;
                    }
                }

                a {
                    text-decoration: none;
                    padding: 0 5px 0 0px;
                    color: $ypo-cta;
                    line-height: 20px;

                    &:hover {
                        color: $ypo-cta-hover;
                    }
                }

                .following {
                    text-transform: none;
                }

                strong {
                    color: $ypo_blue;
                    font-size: 14px;
                    font-weight: bold;
                    line-height: 19px;
                    text-transform: uppercase;
                    cursor: pointer;

                    &:hover {
                        color: $ypo-cta-hover;
                    }

                    i {
                        color: $ypo_blue;
                        font-size: 16px;
                        font-weight: 600;
                        margin-right: 3px;

                        &:hover {
                            color: $ypo-cta-hover;
                        }
                    }
                }
            }
        }

        .notConnected {
            color: $ypo-cta;
            font-size: 14px;
            font-weight: bold;
            line-height: 19px;
            text-transform: uppercase;
            cursor: pointer;
        }

        .mobile-buttons {
            display: flex;
            gap: 12px;
            justify-content: center;
            margin-top: 16px;
            }

        .action-button {
            background-color: $ypo-oceanic-blue;
            min-width: 170px;
            min-height: 40px;
            justify-content: center;
            color: white;
            font-size: 13px;
            font-weight: bold;
            text-transform: uppercase;
            border: none;
            border-radius: 4px;
            padding: 10px 16px;
            display: flex;
            align-items: center;
            gap: 8px;
            cursor: pointer;

                i {
                    display: inline-block;
                    width: 16px;
                    height: 16px;
                    background-size: cover;
                    background-repeat: no-repeat;
                    margin-top: 2px;
                    }
            }
    }

    .upload-photo {
        text-align: center;
        padding: 0;
        margin-right: 0px !important;
        background-color: $ypo-medium-gray;

        i {
            font-size: 20px;
            color: $ypo-medium-gray;
        }

        .rotate_btn {

            label {
                padding: 5px;
            }
        }

        &__actions {
            padding: 13px 0 10px 12px;
            margin-top: 1px;

            .fa-user {
                font-size: 12px;
                color: $ypo-blue;
                background: $white;
                width: 20px;
                border-radius: 50%;
                height: 20px;
                text-align: center;
                line-height: 20px;
            }

            span {
                margin-left: 30px;
                color: $ypo_blue;

                i {
                    font-size: 14px;
                    color: $ypo_blue;
                }

                button:focus {
                    outline: none;
                }

            }

            input[type=range] {
                width: 175px;
                margin: 0 5px;
                position: relative;
                top: -2px;

                &+i {
                    width: 26px;
                    height: 26px;
                    font-size: 16px;
                    line-height: 24px;
                }
                @include breakpoint(xs) {
                width: 125px;
            }
            }
            @include breakpoint(sm) {
                padding: 13px 0 10px 5px;
                    span {
                        margin-left: 0;
                        @include breakpoint(xs) {
                            .v-btn {
                                width: 30px;
                            }
            }
                    }
                }
        }
        &__controls {
            @include breakpoint(sm) {
                .primary_btn {
                    padding: 8px 20px;
                }
            }
            @include breakpoint(xs) {
                .primary_btn {
                    padding: 8px 16px;
                }
            }
        }
    }

    @media (max-width: 1199px) {
        .profile-details {
            &__image {
                left: 0;
            }
        }
    }

    @media (max-width: 767px) {
        .profile-details {
            &__image {
                left: 50%;
                margin-left: -79px;
            }

            &__info {
                text-align: center;
                padding: 170px 0 15px 0;
                border-bottom: 1px dashed $ypo-medium-gray;
                .details {
                    span {
                        .label-gold {
                            display: -webkit-inline-box;
                        }
                    }
                }
            }

        }
    }
</style><style lang="scss">
    @import "../../common/styles/_colors.scss";

    .profile-details figure .v-btn .v-btn__content {
        display: initial;
    }

    .croppa-container {
        background-color: $ypo-medium-gray;
        padding: 0px;
        width: 100%;
        height: 100%;

        &:hover {
            opacity: 1;
        }

        canvas {
            position: relative;
            border: 2px dashed #333;

            &:hover {
                opacity: 0.5;
            }
        }

        &.croppa--has-target {

            canvas {
                border: none;

                &:hover {
                    opacity: 1;
                }
            }
        }
    }

    .slider {
        -webkit-appearance: none;
        width: 100%;
        height: 3px;
        background: $ypo-gray;
        outline: none;
        opacity: 0.7;
        -webkit-transition: .2s;
        transition: opacity .2s;
        border-radius: 50px;
    }

    .slider:hover {
        opacity: 1;
    }

    .slider::-webkit-slider-thumb {
        -webkit-appearance: none;
        appearance: none;
        width: 20px;
        height: 20px;
        background: $ypo-blue;
        cursor: pointer;
        border-radius: 50px;
    }

    .slider::-moz-range-thumb {
        width: 20px;
        height: 20px;
        background: $ypo-blue;
        cursor: pointer;
    }
</style>
